import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import FirstPage from './firstpage';

// Branding pages
import CrunchPage from './pages/Branding/crunchdetails';
import RavenHouse from './pages/Branding/ravenhousedetail';
import Onida from './pages/Branding/onida';

// Illustration pages
import KingKong from './pages/illustrations/kingkong';
import NicotineFree from './pages/illustrations/nicotinefree';
import TheLiving from './pages/illustrations/theliving';
import FeverDreams from './pages/illustrations/feverdreams';
import HaveNoChannel from './pages/illustrations/havenochannel';
import TheWolf from './pages/illustrations/thewolf';
import PeaceAndHoney from './pages/illustrations/peaceandhoney';
import TheLastHand from './pages/illustrations/thelasthand';
import Funeraltape from './pages/illustrations/funeraltape';
import Wolfandknight from './pages/illustrations/theknightandthewolf';


// Bookdesign pages
import ApocalypticAdolescents from './pages/Bookdesign/Apocalypticadolescents';

//Furniture
import Orangecut from './pages/Furnituredesign/orangecut';


function App() {
  return (
    <Router>
      <Routes>
        {/* Main page */}
        <Route path="/" element={<FirstPage />} />
        
        {/* Branding section routes */}
        <Route path="/crunchpage" element={<CrunchPage />} />
        <Route path="/ravenhouse" element={<RavenHouse />} />
        <Route path="/onida" element={<Onida />} />
        
        {/* Illustration section routes */}
        <Route path="/kingkong" element={<KingKong />} />
        <Route path="/nicotinefree" element={<NicotineFree />} />
        <Route path="/theliving" element={<TheLiving />} />
        <Route path="/feverdreams" element={<FeverDreams />} />
        <Route path="/havenochannel" element={<HaveNoChannel />} />
        <Route path="/thewolf" element={<TheWolf />} />
        <Route path="/theknightandthewolf" element={<Wolfandknight />} />
        <Route path="/peaceandhoney" element={<PeaceAndHoney />} />
        <Route path="/thelasthand" element={<TheLastHand />} />
        <Route path="/thefuneraltape" element={<Funeraltape />} />
        
        
        {/*Book design section */}
        <Route path="/apocalyptic" element={<ApocalypticAdolescents />} />

        {/*Book design section */}
        <Route path="/orangecut" element={<Orangecut />} />

      </Routes>
    </Router>
  );
}

export default App;
